import React, { FC, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

import classes from "../../CampaignsDashboard.module.scss";
import { BrandgenCampaignPool } from "../../../../../types/campaignTypes";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";

type CampaignsSelectorProps = {
  selectedCampaignPool: BrandgenCampaignPool;
  options: SelectOptionType[];
  handleChangeSelectedCampaign: (value: SelectOptionType | null) => void;
};

const CampaignsSelector: FC<CampaignsSelectorProps> = ({
  selectedCampaignPool,
  options,
  handleChangeSelectedCampaign,
}) => {
  const [inputValue, setInputValue] = useState("");

  const selectedOption =
    options.find((option) => option.value === selectedCampaignPool.brandgenCampaignPoolId) ?? undefined;

  return (
    <Autocomplete
      className={classes.selector}
      value={selectedOption}
      onChange={(event, newValue) => handleChangeSelectedCampaign(newValue)}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      options={options}
      disableClearable
      getOptionLabel={(option) => option.label || ""}
      getOptionSelected={(option, value) => option.value === value?.value && option.label === value?.label}
      renderInput={(params) => <TextField {...params} label="Campaigns" variant="outlined" />}
    />
  );
};

export default CampaignsSelector;
